import {
  RESET_PASSWORD_BEGIN,
  RESET_PASSWORD_FAILED,
  RESET_PASSWORD_SUCCESS,
} from "../actions/resetpasswordactions";

const initialState = {
  loading: false,
};

export function resetPasswordReducer(state = initialState, action) {
  const nextState = Object.assign({}, state);

  switch (action.type) {
    case RESET_PASSWORD_BEGIN:
      nextState.loading = true;
      return nextState;
    case RESET_PASSWORD_SUCCESS:
      nextState.loading = false;
      return nextState;
    case RESET_PASSWORD_FAILED:
      nextState.loading = false;
      return nextState;
    default:
      return state;
  }
}
